import { StaticFieldIds } from 'app/apps/template-forms/template-forms-register/forms-register-static-fields/static-field-ids.enum';

import { CategoryHeader } from './category/register/category-header';
import { FormFieldHeader } from './common/register/form-field-header/form-field-header';
import { DateHeader } from './date/register/date-header';
import { MultiLineInputHeader } from './multi-line-input/register/multi-line-input-header';
import { PersonHeader } from './person/register/person-header';
import { SignonTableRegisterHeader } from './signon-table/register/signon-table-register-header';
import { SingleLineInputHeader } from './single-line-input/register/single-line-input-header';
import { PrefilledTableHeader } from './table/register/prefilled-table-header';
import { TableHeader } from './table/register/table-header';
import { WorkflowStepHeader } from './workflow-step/register/workflow-step-header';
import { YesNoHeader } from './yes-no/register/yes-no-header';

export class FormFieldHeaderFactory {
  private static resolver = {
    category: CategoryHeader,
    date: DateHeader,
    table: TableHeader,
    list: CategoryHeader,
    person: PersonHeader,
    prefilledTable: PrefilledTableHeader,
    signonTable: SignonTableRegisterHeader,
    yesNoCheckbox: YesNoHeader,
    user: CategoryHeader,
    singleLineInput: SingleLineInputHeader,
    multiLineInput: MultiLineInputHeader,
    workflowStep: WorkflowStepHeader,
    text: SingleLineInputHeader,
  };

  private static defaultHeader = FormFieldHeader;
  private static staticFieldsWithDefaultHeader = [StaticFieldIds.UpdatedAt];

  static getHeader(item): FormFieldHeader {
    const shouldHaveDefaultHeader =
      this.staticFieldsWithDefaultHeader.includes(item.id) || !this.resolver[item.kind];

    const HeaderClass = shouldHaveDefaultHeader ? this.defaultHeader : this.resolver[item.kind];
    // table header needs access to the FormFieldHeaderFactory instance for filling in its columns
    const header = HeaderClass === TableHeader ? new HeaderClass(item, this) : new HeaderClass(item);
    return header;
  }
}
